export class UserRequest {
  constructor(email, apiKey, resetStatus = false, requestType, inputOtp) {
    this.email = email;
    this.apiKey = apiKey;
    this.resetStatus = resetStatus;
    this.requestType = requestType;
    this.inputOtp = inputOtp;
  }
}
